export const formatPrice = (price: number | null): string => {
  if (price === null || isNaN(price)) return "$ 0.00";
  return `$ ${price.toFixed(2)}`;
};
